<div class="example-button-container">
  <button
    routerLink="/home"
    mat-fab
    aria-label="Home button"
    matTooltip="Home"
    matTooltipPosition="left"
  >
    <i class="fa-solid fa-house"></i>
  </button>
</div>
